var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankProfileSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#384047",
    d: "M7.897 7.628a3.602 3.602 0 0 0 3.598-3.598A3.602 3.602 0 0 0 7.897.432 3.602 3.602 0 0 0 4.3 4.03a3.602 3.602 0 0 0 3.598 3.598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#384047",
    d: "M11.652 8.688a5.968 5.968 0 0 1-7.51 0A7.193 7.193 0 0 0 .706 14.82v1.195h14.383v-1.195a7.193 7.193 0 0 0-3.437-6.13z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProfileSmall);
export default __webpack_public_path__ + "static/media/blankProfileSmall.85e767e6dd7132de96b72151dbe47738.svg";
export { ForwardRef as ReactComponent };